module.exports = __webpack_public_path__ + "media/netflix.67fbdddc.wav";